import {
  isSupportedUiLocale,
  languageCodeToUiLocale,
  resolveBrowserUiLocale,
  type UiLocale,
} from '../core/contracts.js'

export interface UnifiedLocaleSnapshot {
  uiLocale?: UiLocale | undefined
  uiLocaleExplicit?: boolean | undefined
  language?: string | undefined
  livePolicyLanguageCode?: string | undefined
}

/** Resolution order: explicit saved UI locale → saved language → browser → default. */
export function resolveUiLocale(snapshot: UnifiedLocaleSnapshot): UiLocale {
  if (snapshot.uiLocale && isSupportedUiLocale(snapshot.uiLocale)) {
    return snapshot.uiLocale
  }

  const fromLanguage =
    languageCodeToUiLocale(snapshot.livePolicyLanguageCode) ??
    languageCodeToUiLocale(snapshot.language)
  if (fromLanguage) {
    return fromLanguage
  }

  return resolveBrowserUiLocale()
}

export function isUiLocaleExplicit(snapshot: UnifiedLocaleSnapshot): boolean {
  return snapshot.uiLocaleExplicit === true
}
